{
    "it": {
        "Yes": "Sì",
        "No": "No",
        "Cancel": "Annulla",
        "CheckState": "Stato selezione",
        "Close": "Chiudi",
        "Clear": "Cancella",
        "Done": "Fatto",
        "Loading": "Caricamento...",
        "Select": "Seleziona...",
        "Search": "Cerca",
        "Back": "Indietro",
        "OK": "OK",
        "Today": "Oggi",
        "Yesterday": "Ieri",

        "dxCollectionWidget-noDataText": "Nessun dato da mostrare",

        "dxDropDownEditor-selectLabel": "Seleziona",

        "validation-required": "Richiesto",
        "validation-required-formatted": "{0} è richiesto",
        "validation-numeric": "Il valore deve essere numerico",
        "validation-numeric-formatted": "{0} deve essere numerico",
        "validation-range": "Il valore non è compreso nell'intervallo",
        "validation-range-formatted": "{0} non è compreso nell'intervallo",
        "validation-stringLength": "Lunghezza del valore errata",
        "validation-stringLength-formatted": "La lunghezza di {0} è errata",
        "validation-custom": "Il valore non è corretto",
        "validation-custom-formatted": "{0} non è corretto",
        "validation-async": "Il valore non è corretto",
        "validation-async-formatted": "{0} non è corretto",
        "validation-compare": "I valori non corrispondono",
        "validation-compare-formatted": "{0} non corrisponde",
        "validation-pattern": "Il valore non rispetta il formato previsto",
        "validation-pattern-formatted": "{0} non rispetta il formato previsto",
        "validation-email": "L'email non è corretta",
        "validation-email-formatted": "{0} non è una email corretta",
        "validation-mask": "Il valore non è corretto",

        "dxLookup-searchPlaceholder": "Inserisci almeno {0} caratteri",

        "dxList-pullingDownText": "Trascina in basso per aggiornare...",
        "dxList-pulledDownText": "Rilascia per aggiornare...",
        "dxList-refreshingText": "Aggiornamento...",
        "dxList-pageLoadingText": "Caricamento...",
        "dxList-nextButtonText": "Carica altri elementi",
        "dxList-selectAll": "Seleziona tutti",
        "dxList-listAriaLabel": "Elementi",
        "dxList-listAriaLabel-deletable": "Elementi eliminabili",
        "dxListEditDecorator-delete": "Elimina",
        "dxListEditDecorator-more": "Ancora",
        "dxList-selectAll-indeterminate": "Parzialmente selezionato",
        "dxList-selectAll-checked": "Selezionato",
        "dxList-selectAll-notChecked": "Non selezionato",
        "dxList-ariaRoleDescription": "Lista",
        "dxList-listAriaLabel-itemContent": "Contenuto elemento lista",

        "dxScrollView-pullingDownText": "Trascina in basso per aggiornare...",
        "dxScrollView-pulledDownText": "Rilascia per aggiornare...",
        "dxScrollView-refreshingText": "Aggiornamento...",
        "dxScrollView-reachBottomText": "Caricamento...",

        "dxDateBox-simulatedDataPickerTitleTime": "Seleziona orario",
        "dxDateBox-simulatedDataPickerTitleDate": "Seleziona data",
        "dxDateBox-simulatedDataPickerTitleDateTime": "Seleziona data e ora",
        "dxDateBox-validation-datetime": "Il valore deve essere una data o un orario",

        "dxDateRangeBox-invalidStartDateMessage": "Il valore iniziale deve essere una data",
        "dxDateRangeBox-invalidEndDateMessage": "Il valore finale deve essere una data",
        "dxDateRangeBox-startDateOutOfRangeMessage": "La data di inizio è fuori intervallo",
        "dxDateRangeBox-endDateOutOfRangeMessage": "La data di fine è fuori intervallo",
        "dxDateRangeBox-startDateLabel": "Data inizio",
        "dxDateRangeBox-endDateLabel": "Data fine",

        "dxFileUploader-selectFile": "Seleziona file",
        "dxFileUploader-dropFile": "o trascina il file qui",
        "dxFileUploader-bytes": "bytes",
        "dxFileUploader-kb": "KB",
        "dxFileUploader-Mb": "MB",
        "dxFileUploader-Gb": "GB",
        "dxFileUploader-upload": "Carica",
        "dxFileUploader-uploaded": "Caricato",
        "dxFileUploader-readyToUpload": "Pronto per caricare",
        "dxFileUploader-uploadAbortedMessage": "Caricamento annullato",
        "dxFileUploader-uploadFailedMessage": "Caricamento fallito",
        "dxFileUploader-invalidFileExtension": "Il tipo di file non è consentito",
        "dxFileUploader-invalidMaxFileSize": "File troppo grande",
        "dxFileUploader-invalidMinFileSize": "File troppo piccolo",
        "dxFileUploader-fileListLabel": "Lista file",
        "dxFileUploader-removeFileButtonLabel": "Rimuovi file {0}",
        "dxFileUploader-uploadFileButtonLabel": "Carica file {0}",

        "dxRangeSlider-ariaFrom": "Da",
        "dxRangeSlider-ariaTill": "A",
        "dxSwitch-switchedOnText": "ON",
        "dxSwitch-switchedOffText": "OFF",

        "dxForm-optionalMark": "opzionale",
        "dxForm-requiredMessage": "{0} è richiesto",
        "dxForm-smartPasteButtonText": "Incolla intelligente",
        "dxForm-resetButtonText": "Reimposta",
        "dxForm-submitButtonText": "Invia",

        "dxNumberBox-invalidValueMessage": "Il valore deve essere numerico",
        "dxNumberBox-noDataText": "Nessun dato",


        "dxDataGrid-aiAssistantTitle": "Assistente IA",
        "dxDataGrid-aiAssistantProcessingMessageHeader": "Richiesta in corso",
        "dxDataGrid-aiAssistantProcessingMessage": "Elaborazione in corso...",
        "dxDataGrid-aiAssistantErrorMessageHeader": "Impossibile elaborare la richiesta",
        "dxDataGrid-aiAssistantAbortMessage": "Richiesta interrotta.",
        "dxDataGrid-aiAssistantSuccessMessage": "Operazione riuscita",
        "dxDataGrid-aiAssistantErrorMessage": "Errore",
        "dxDataGrid-aiAssistantExecutionAbortMessage": "Esecuzione interrotta",
        "dxDataGrid-aiAssistantExecutionInProgressMessage": "Esecuzione già in corso. Attendere.",
        "dxDataGrid-aiAssistantRequestInProgressMessage": "Richiesta già in corso. Attendere.",
        "dxDataGrid-aiAssistantUnexpectedErrorMessage": "Si è verificato un errore imprevisto. Riprovare.",
        "dxDataGrid-aiAssistantInvalidResponseMessage": "Risposta non valida dal servizio IA. Riprovare.",
        "dxDataGrid-aiAssistantClearButtonText": "Svuota",
        "dxDataGrid-aiAssistantRegenerateButtonText": "Rigenera",
        "dxDataGrid-aiAssistantAbortConfirmText": "La chiusura della chat dell'Assistente IA interrompe le richieste in corso. Chiudere la chat?",
        "dxDataGrid-aiAChatEmptyViewMessage": "La chat è vuota",
        "dxDataGrid-aiChatEmptyViewPrompt": "L'Assistente IA è pronto a rispondere alle Sue domande.",
        "dxDataGrid-aiPromptEditorTitle": "Editor prompt AI",
        "dxDataGrid-aiPromptEditorPlaceholder": "Chiedi all'AI di generare i valori delle colonne...",
        "dxDataGrid-aiPromptEditorApplyButton": "Applica",
        "dxDataGrid-aiPromptEditorRegenerateButton": "Rigenera dati",
        "dxDataGrid-aiPromptEditorStopButton": "Interrompi",
        "dxDataGrid-aiDropDownAutofill": "Compilazione automatica con AI",
        "dxDataGrid-aiDropDownClear": "Cancella dati",
        "dxDataGrid-emptyHeaderWithColumnChooserText": "Usa {0} per visualizzare le colonne",
        "dxDataGrid-emptyHeaderWithGroupPanelText": "Trascina qui una colonna dal pannello di raggruppamento",
        "dxDataGrid-emptyHeaderWithColumnChooserAndGroupPanelText": "Usa {0} o trascina una colonna dal pannello di raggruppamento",
        "dxDataGrid-emptyHeaderColumnChooserText": "il selettore colonne",
        "dxDataGrid-columnChooserTitle": "Selettore colonne",
        "dxDataGrid-columnChooserEmptyText": "Trascina qui una colonna per nasconderla",
        "dxDataGrid-groupContinuesMessage": "Continua alla pagina successiva",
        "dxDataGrid-groupContinuedMessage": "Continua dalla pagina precedente",
        "dxDataGrid-groupHeaderText": "Raggruppa per questa colonna",
        "dxDataGrid-ungroupHeaderText": "Rimuovi raggruppamento",
        "dxDataGrid-ungroupAllText": "Rimuovi tutti i raggruppamenti",
        "dxDataGrid-editingEditRow": "Modifica",
        "dxDataGrid-editingSaveRowChanges": "Salva",
        "dxDataGrid-editingCancelRowChanges": "Annulla",
        "dxDataGrid-editingDeleteRow": "Elimina",
        "dxDataGrid-editingUndeleteRow": "Ripristina",
        "dxDataGrid-editingConfirmDeleteMessage": "Sei certo di voler eliminare questo record?",
        "dxDataGrid-validationCancelChanges": "Annulla le modifiche",
        "dxDataGrid-groupPanelEmptyText": "Trascina qui l'intestazione di una colonna per raggrupparla",
        "dxDataGrid-noDataText": "Nessun dato",
        "dxDataGrid-searchPanelPlaceholder": "Cerca...",
        "dxDataGrid-filterRowShowAllText": "(Tutti)",
        "dxDataGrid-filterRowResetOperationText": "Cancella filtro",
        "dxDataGrid-filterRowOperationEquals": "Uguale",
        "dxDataGrid-filterRowOperationNotEquals": "Diverso",
        "dxDataGrid-filterRowOperationLess": "Minore di",
        "dxDataGrid-filterRowOperationLessOrEquals": "Minore o uguale a",
        "dxDataGrid-filterRowOperationGreater": "Maggiore di",
        "dxDataGrid-filterRowOperationGreaterOrEquals": "Maggiore o uguale a",
        "dxDataGrid-filterRowOperationStartsWith": "Inizia con",
        "dxDataGrid-filterRowOperationContains": "Contiene",
        "dxDataGrid-filterRowOperationNotContains": "Non contiene",
        "dxDataGrid-filterRowOperationEndsWith": "Termina con",
        "dxDataGrid-filterRowOperationBetween": "Compreso",
        "dxDataGrid-filterRowOperationBetweenStartText": "Inizio",
        "dxDataGrid-filterRowOperationBetweenEndText": "Fine",
        "dxDataGrid-ariaSearchBox": "Casella di ricerca",
        "dxDataGrid-applyFilterText": "Applica filtro",
        "dxDataGrid-trueText": "vero",
        "dxDataGrid-falseText": "falso",
        "dxDataGrid-sortingAscendingText": "Ordinamento ascendente",
        "dxDataGrid-sortingDescendingText": "Ordinamento discendente",
        "dxDataGrid-sortingClearText": "Annulla ordinamento",
        "dxDataGrid-ariaNotSortedColumn": "Colonna non ordinata",
        "dxDataGrid-ariaSortedAscendingColumn": "Colonna ordinata in modo crescente",
        "dxDataGrid-ariaSortedDescendingColumn": "Colonna ordinata in modo decrescente",
        "dxDataGrid-ariaSortIndex": "Indice di ordinamento {0}",
        "dxDataGrid-editingSaveAllChanges": "Salva le modifiche",
        "dxDataGrid-editingCancelAllChanges": "Annulla le modifiche",
        "dxDataGrid-editingAddRow": "Aggiungi una riga",
        "dxDataGrid-summaryMin": "Min: {0}",
        "dxDataGrid-summaryMinOtherColumn": "Min di {1} è {0}",
        "dxDataGrid-summaryMax": "Max: {0}",
        "dxDataGrid-summaryMaxOtherColumn": "Max di {1} è {0}",
        "dxDataGrid-summaryAvg": "Media: {0}",
        "dxDataGrid-summaryAvgOtherColumn": "Media di {1} è {0}",
        "dxDataGrid-summarySum": "Somma: {0}",
        "dxDataGrid-summarySumOtherColumn": "Somma di {1} è {0}",
        "dxDataGrid-summaryCount": "Conteggio: {0}",
        "dxDataGrid-columnFixingFix": "Imposta posizione fissa",
        "dxDataGrid-columnFixingUnfix": "Sblocca posizione",
        "dxDataGrid-columnFixingLeftPosition": "Sinistra",
        "dxDataGrid-columnFixingRightPosition": "Destra",
        "dxDataGrid-columnFixingStickyPosition": "Fisso",
        "dxDataGrid-exportTo": "Esporta",
        "dxDataGrid-exportToExcel": "Esporta in Excel",
        "dxDataGrid-exporting": "Esportazione...",
        "dxDataGrid-excelFormat": "File Excel",
        "dxDataGrid-selectedRows": "Righe selezionate",
        "dxDataGrid-exportSelectedRows": "Esporta le righe selezionate in {0}",
        "dxDataGrid-exportAll": "Esporta tutti i dati in {0}",
        "dxDataGrid-headerFilterLabel": "Opzioni filtro",
        "dxDataGrid-headerFilterIndicatorLabel": "Mostra le opzioni filtro per la colonna '{0}'",
        "dxDataGrid-headerFilterEmptyValue": "(vuoto)",
        "dxDataGrid-headerFilterOK": "OK",
        "dxDataGrid-headerFilterCancel": "Annulla",
        "dxDataGrid-ariaAdaptiveCollapse": "Nascondi ulteriori dati",
        "dxDataGrid-ariaAdaptiveExpand": "Mostra ulteriori dati",
        "dxDataGrid-ariaColumn": "Colonna",
        "dxDataGrid-ariaColumnHeader": "Intestazione colonna",
        "dxDataGrid-ariaValue": "Valore",
        "dxDataGrid-ariaError": "Errore",
        "dxDataGrid-ariaRevertButton": "Premere Escape per annullare le modifiche",
        "dxDataGrid-ariaFilterCell": "Filtra cella",
        "dxDataGrid-ariaCollapse": "Comprimi",
        "dxDataGrid-ariaModifiedCell": "Modificato",
        "dxDataGrid-ariaDeletedCell": "Eliminato",
        "dxDataGrid-ariaEditableCell": "Modificabile",
        "dxDataGrid-ariaExpand": "Espandi",
        "dxDataGrid-ariaCollapsedRow": "Riga compressa",
        "dxDataGrid-ariaExpandedRow": "Riga espansa",
        "dxDataGrid-ariaDataGrid": "Griglia dati con {0} righe e {1} colonne",
        "dxDataGrid-ariaSearchInGrid": "Cerca nella griglia",
        "dxDataGrid-ariaSelectAll": "Seleziona tutti",
        "dxDataGrid-ariaSelectRow": "Seleziona riga",
        "dxDataGrid-ariaToolbar": "Barra degli strumenti griglia",
        "dxDataGrid-ariaEditForm": "Modulo di modifica",
        "dxDataGrid-filterBuilderPopupTitle": "Composizione filtro",
        "dxDataGrid-filterPanelCreateFilter": "Nuovo filtro",
        "dxDataGrid-filterPanelClearFilter": "Cancella",
        "dxDataGrid-filterPanelFilterEnabledHint": "Attiva il filtro",
        "dxDataGrid-masterDetail": "Cella con dettagli",
        "dxDataGrid-moveColumnToTheRight": "Sposta a destra",
        "dxDataGrid-moveColumnToTheLeft": "Sposta a sinistra",

        "dxTreeList-ariaTreeList": "Lista ad albero con {0} righe e {1} colonne",
        "dxTreeList-ariaExpandableInstruction": "Premere Ctrl + freccia destra per espandere il nodo selezionato e Ctrl + freccia sinistra per comprimerlo",
        "dxTreeList-ariaSearchInGrid": "Ricerca nell'albero",
        "dxTreeList-ariaToolbar": "Barra degli strumenti albero",
        "dxTreeList-editingAddRowToNode": "Aggiungi",

        "dxPager-infoText": "Pagina {0} di {1} ({2} elementi)",
        "dxPager-pagesCountText": "di",
        "dxPager-pageSize": "Elementi per pagina: {0}",
        "dxPager-pageSizesAllText": "Tutti",
        "dxPager-page": "Pagina {0}",
        "dxPager-prevPage": "Pagina precedente",
        "dxPager-nextPage": "Pagina successiva",
        "dxPager-ariaLabel": "Navigazione pagine",
        "dxPager-ariaPageSize": "Dimensione pagina",
        "dxPager-ariaPageNumber": "Numero pagina",

        "dxPagination-infoText": "Pagina {0} di {1} ({2} elementi)",
        "dxPagination-pagesCountText": "di",
        "dxPagination-pageSize": "Elementi per pagina: {0}",
        "dxPagination-pageSizesAllText": "Tutti",
        "dxPagination-page": "Pagina {0}",
        "dxPagination-prevPage": "Pagina precedente",
        "dxPagination-nextPage": "Pagina successiva",
        "dxPagination-ariaLabel": "Navigazione pagine",
        "dxPagination-ariaPageSize": "Dimensione pagina",
        "dxPagination-ariaPageNumber": "Numero pagina",

        "dxPivotGrid-ariaLabel": "Pivot grid",
        "dxPivotGrid-grandTotal": "Totale",
        "dxPivotGrid-total": "{0} Totale",
        "dxPivotGrid-fieldChooserTitle": "Selezione campi",
        "dxPivotGrid-showFieldChooser": "Mostra selezione campi",
        "dxPivotGrid-expandAll": "Espandi tutto",
        "dxPivotGrid-collapseAll": "Comprimi tutto",
        "dxPivotGrid-sortColumnBySummary": "Ordina \"{0}\" per questa colonna",
        "dxPivotGrid-sortRowBySummary": "Ordina \"{0}\" per questa riga",
        "dxPivotGrid-removeAllSorting": "Rimuovi ordinamenti",
        "dxPivotGrid-dataNotAvailable": "N/D",
        "dxPivotGrid-rowFields": "Campi riga",
        "dxPivotGrid-columnFields": "Campi colonna",
        "dxPivotGrid-dataFields": "Campi dati",
        "dxPivotGrid-filterFields": "Campi filtro",
        "dxPivotGrid-allFields": "Tutti i campi",
        "dxPivotGrid-columnFieldArea": "Trascina qui i campi colonna",
        "dxPivotGrid-dataFieldArea": "Trascina qui i campi dati",
        "dxPivotGrid-rowFieldArea": "Trascina qui i campi riga",
        "dxPivotGrid-filterFieldArea": "Trascina qui i campi filtro",

        "dxScheduler-dateRange": "da {0} a {1}",
        "dxScheduler-ariaLabel": "Pianificatore. Vista {0}: {1} con {2} appuntamenti",
        "dxScheduler-ariaLabel-currentIndicator-present": "L'indicatore dell'orario corrente è visibile nella vista",
        "dxScheduler-ariaLabel-currentIndicator-not-present": "L'indicatore dell'orario corrente non è visibile nella schermata",

        "dxScheduler-appointmentAriaDescription-group": "Gruppo: {0}",
        "dxScheduler-appointmentAriaLabel-recurring": "Appuntamento ricorrente",
        "dxScheduler-hotkeysAriaDescription-delete": "Premere Elimina per eliminare questo appuntamento",
        "dxScheduler-hotkeysAriaDescription-homeEnd": "Premere Home o Fine per spostarsi rapidamente al primo o all'ultimo appuntamento",

        "dxScheduler-appointmentListAriaLabel": "Lista appuntamenti",
        "dxScheduler-newPopupTitle": "Nuovo appuntamento",
        "dxScheduler-editPopupTitle": "Modifica appuntamento",
        "dxScheduler-editPopupSaveButtonText": "Salva",

        "dxScheduler-editorLabelTitle": "Oggetto",
        "dxScheduler-editorLabelStartDate": "Data inizio",
        "dxScheduler-editorAriaLabelStartTime": "Orario di inizio",
        "dxScheduler-editorLabelEndDate": "Data fine",
        "dxScheduler-editorAriaLabelEndTime": "Orario di fine",
        "dxScheduler-editorLabelDescription": "Descrizione",
        "dxScheduler-editorLabelRecurrence": "Ripeti",

        "dxScheduler-noSubject": "(Nessun oggetto)",

        "dxScheduler-navigationToday": "Oggi",
        "dxScheduler-navigationPrevious": "Pagina precedente",
        "dxScheduler-navigationNext": "Pagina successiva",

        "dxScheduler-openAppointment": "Apri appuntamento",

        "dxScheduler-recurrenceNever": "Mai",
        "dxScheduler-recurrenceMinutely": "Ogni minuto",
        "dxScheduler-recurrenceHourly": "Ogni ora",
        "dxScheduler-recurrenceDaily": "Giornaliero",
        "dxScheduler-recurrenceWeekly": "Settimanale",
        "dxScheduler-recurrenceMonthly": "Mensile",
        "dxScheduler-recurrenceYearly": "Annuale",

        "dxScheduler-recurrenceRepeatEvery": "Ogni",
        "dxScheduler-recurrenceRepeatOn": "Ripeti il",
        "dxScheduler-recurrenceEnd": "Termina ripetizione",
        "dxScheduler-recurrenceAfter": "Dopo",
        "dxScheduler-recurrenceOn": "Il giorno",

        "dxScheduler-recurrenceUntilDateLabel": "Data di fine ripetizione",
        "dxScheduler-recurrenceOccurrenceLabel": "Numero di occorrenze",

        "dxScheduler-recurrenceRepeatMinutely": "minuto(u)",
        "dxScheduler-recurrenceRepeatHourly": "ora(e)",
        "dxScheduler-recurrenceRepeatDaily": "giorno(i)",
        "dxScheduler-recurrenceRepeatWeekly": "settimana(e)",
        "dxScheduler-recurrenceRepeatMonthly": "mese(i)",
        "dxScheduler-recurrenceRepeatYearly": "anno(i)",

        "dxScheduler-switcherDay": "Giorno",
        "dxScheduler-switcherWeek": "Settimana",
        "dxScheduler-switcherWorkWeek": "Settimana lavorativa",
        "dxScheduler-switcherMonth": "Mese",

        "dxScheduler-switcherAgenda": "Agenda",

        "dxScheduler-switcherTimelineDay": "Cronologia giornaliera",
        "dxScheduler-switcherTimelineWeek": "Cronologia settimanale",
        "dxScheduler-switcherTimelineWorkWeek": "Cronologia settimana lavorativa",
        "dxScheduler-switcherTimelineMonth": "Cronologia mensile",

        "dxScheduler-recurrenceRepeatOnDate": "alla data",
        "dxScheduler-recurrenceRepeatCount": "occorrenza(e)",
        "dxScheduler-allDay": "Tutto il giorno",

        "dxScheduler-ariaEditForm": "Modulo di modifica",

        "dxScheduler-confirmRecurrenceEditTitle": "Modifica appuntamento ricorrente",
        "dxScheduler-confirmRecurrenceDeleteTitle": "Elimina appuntamento ricorrente",

        "dxScheduler-confirmRecurrenceEditMessage": "Vuoi modificare solo questo appuntamento o tutte le sue ricorrenze?",
        "dxScheduler-confirmRecurrenceDeleteMessage": "Vuoi eliminare solo questo appuntamento o tutte le sue ricorrenze?",

        "dxScheduler-confirmRecurrenceEditSeries": "Modifica serie",
        "dxScheduler-confirmRecurrenceDeleteSeries": "Elimina serie",
        "dxScheduler-confirmRecurrenceEditOccurrence": "Modifica appuntamento",
        "dxScheduler-confirmRecurrenceDeleteOccurrence": "Elimina appuntamento",

        "dxScheduler-noTimezoneTitle": "Nessun fuso orario",
        "dxScheduler-moreAppointments": "{0} ancora",

        "dxCalendar-currentDay": "Oggi",
        "dxCalendar-currentMonth": "Mese corrente",
        "dxCalendar-currentYear": "Anno corrente",
        "dxCalendar-currentYearRange": "Intervallo anno corrente",
        "dxCalendar-todayButtonText": "Oggi",
        "dxCalendar-ariaWidgetName": "Calendario",
        "dxCalendar-previousMonthButtonLabel": "Mese precedente",
        "dxCalendar-previousYearButtonLabel": "Anno precedente",
        "dxCalendar-previousDecadeButtonLabel": "Decennio precedente",
        "dxCalendar-previousCenturyButtonLabel": "Secolo precedente",
        "dxCalendar-nextMonthButtonLabel": "Mese successivo",
        "dxCalendar-nextYearButtonLabel": "Anno successivo",
        "dxCalendar-nextDecadeButtonLabel": "Decennio successivo",
        "dxCalendar-nextCenturyButtonLabel": "Secolo successivo",
        "dxCalendar-captionMonthLabel": "Selezione mese",
        "dxCalendar-captionYearLabel": "Selezione anno",
        "dxCalendar-captionDecadeLabel": "Selezione decennio",
        "dxCalendar-captionCenturyLabel": "Selezione secolo",
        "dxCalendar-selectedDate": "La data selezionata è {0}",
        "dxCalendar-selectedDates": "Le date selezionate",
        "dxCalendar-selectedDateRange": "L'intervallo di date selezionato va da {0} a {1}",
        "dxCalendar-selectedMultipleDateRange": "da {0} a {1}",
        "dxCalendar-selectedDateRangeCount": "Ci sono {0} intervalli di date selezionati",
        "dxCalendar-readOnlyLabel": "Calendario in sola lettura",

        "dxCardView-ariaSearchInGrid": "Cerca nella vista a schede",
        "dxCardView-ariaHeaderItemLabel": "Nome campo {0}",
        "dxCardView-ariaHeaderItemSortingAscendingLabel": "Ordinato in modo crescente",
        "dxCardView-ariaHeaderItemSortingDescendingLabel": "Ordinato in modo decrescente",
        "dxCardView-ariaHeaderItemSortingIndexLabel": "Indice di ordinamento {0}",
        "dxCardView-ariaHeaderHasHeaderFilterLabel": "Filtro intestazione applicato",
        "dxCardView-ariaSelectCard": "Seleziona scheda",
        "dxCardView-ariaCardView": "Vista a schede con {0} schede. Ogni scheda ha {1} campi",
        "dxCardView-ariaCard": "Scheda",
        "dxCardView-ariaEditableCard": "Scheda modificabile",
        "dxCardView-ariaCardPosition": "Riga {0}, colonna {1}",
        "dxCardView-ariaSelectedCardState": "Selezionato",
        "dxCardView-ariaNotSelectedCardState": "Non selezionato",
        "dxCardView-selectAll": "Seleziona tutto",
        "dxCardView-clearSelection": "Cancella selezione",
        "dxCardView-cardNoImageAriaLabel": "Nessuna immagine",
        "dxCardView-headerItemDropZoneText": "Trascina l'elemento intestazione qui",
        "dxCardView-emptyHeaderPanelText": "Usa {0} per visualizzare le colonne",
        "dxCardView-emptyHeaderPanelColumnChooserText": "selettore colonne",

        "dxAvatar-defaultImageAlt": "Avatar",

        "dxChat-elementAriaLabel": "Chat",
        "dxChat-textareaPlaceholder": "Scrivi un messaggio",
        "dxChat-sendButtonAriaLabel": "Invia",
        "dxChat-cancelEditingButtonAriaLabel": "Annulla",
        "dxChat-editingMessageCaption": "Modifica messaggio",
        "dxChat-defaultUserName": "Utente sconosciuto",
        "dxChat-messageListAriaLabel": "Lista messaggi",
        "dxChat-alertListAriaLabel": "Lista errori",
        "dxChat-emptyListMessage": "Non ci sono messaggi in questa chat",
        "dxChat-emptyListPrompt": "Scrivi il tuo primo messaggio",
        "dxChat-typingMessageSingleUser": "{0} sta scrivendo...",
        "dxChat-typingMessageTwoUsers": "{0} e {1} stanno scrivendo...",
        "dxChat-typingMessageThreeUsers": "{0}, {1} e {2} stanno scrivendo...",
        "dxChat-typingMessageMultipleUsers": "{0} e altri stanno scrivendo...",
        "dxChat-editedMessageText": "Modificato",
        "dxChat-editingEditMessage": "Modifica",
        "dxChat-editingDeleteMessage": "Elimina",
        "dxChat-editingDeleteConfirmText": "Sei sicuro di voler eliminare questo messaggio?",
        "dxChat-deletedMessageText": "Questo messaggio è stato eliminato",
        "dxChat-defaultImageAlt": "Immagine condivisa in chat",
        "dxChat-fileViewLabel": "Lista file",
        "dxChat-downloadButtonLabel": "Scarica file {0}",
        "dxChat-fileLimitReachedWarning": "Hai selezionato troppi file. Seleziona al massimo {0} file e riprova.",

        "dxColorView-ariaRed": "Rosso",
        "dxColorView-ariaGreen": "Verde",
        "dxColorView-ariaBlue": "Blu",
        "dxColorView-ariaAlpha": "Trasparenza",
        "dxColorView-ariaHex": "Colore",

        "dxTagBox-selected": "{0} selezionati",
        "dxTagBox-allSelected": "Tutti selezionati ({0})",
        "dxTagBox-moreSelected": "{0} ancora",
        "dxTagBox-tagRoleDescription": "Tag. Premere il pulsante elimina per rimuovere questo tag",
        "dxTagBox-ariaRoleDescription": "Casella tag",

        "vizExport-printingButtonText": "Stampa",
        "vizExport-titleMenuText": "Esportazione/Stampa",
        "vizExport-exportButtonText": "{0} file",

        "dxFilterBuilder-and": "E",
        "dxFilterBuilder-or": "O",
        "dxFilterBuilder-notAnd": "E non",
        "dxFilterBuilder-notOr": "O non",
        "dxFilterBuilder-addCondition": "Aggiungi condizione",
        "dxFilterBuilder-addGroup": "Aggiungi gruppo",
        "dxFilterBuilder-enterValueText": "<inserisci un valore>",
        "dxFilterBuilder-filterOperationEquals": "Uguale a",
        "dxFilterBuilder-filterOperationNotEquals": "Diverso da",
        "dxFilterBuilder-filterOperationLess": "Minore di",
        "dxFilterBuilder-filterOperationLessOrEquals": "Minore o uguale a",
        "dxFilterBuilder-filterOperationGreater": "Maggiore di",
        "dxFilterBuilder-filterOperationGreaterOrEquals": "Maggiore o uguale a",
        "dxFilterBuilder-filterOperationStartsWith": "Inizia con",
        "dxFilterBuilder-filterOperationContains": "Contiene",
        "dxFilterBuilder-filterOperationNotContains": "Non contiene",
        "dxFilterBuilder-filterOperationEndsWith": "Termina con",
        "dxFilterBuilder-filterOperationIsBlank": "È vuoto",
        "dxFilterBuilder-filterOperationIsNotBlank": "Non è vuoto",
        "dxFilterBuilder-filterOperationBetween": "Compreso",
        "dxFilterBuilder-filterOperationAnyOf": "Include",
        "dxFilterBuilder-filterOperationNoneOf": "Non include",
        "dxFilterBuilder-filterAriaRootElement": "Generatore filtri",
        "dxFilterBuilder-filterAriaGroupLevel": "Livello {0}",
        "dxFilterBuilder-filterAriaGroupItem": "Elemento gruppo",
        "dxFilterBuilder-filterAriaOperationButton": "Operazione",
        "dxFilterBuilder-filterAriaAddButton": "Aggiungi",
        "dxFilterBuilder-filterAriaRemoveButton": "Rimuovi {0}",
        "dxFilterBuilder-filterAriaItemField": "Campo elemento",
        "dxFilterBuilder-filterAriaItemOperation": "Operazione elemento",
        "dxFilterBuilder-filterAriaItemValue": "Valore elemento",

        "dxHtmlEditor-dialogColorCaption": "Cambia il colore del testo",
        "dxHtmlEditor-dialogBackgroundCaption": "Cambia il colore di sfondo",
        "dxHtmlEditor-dialogLinkCaption": "Aggiungi Link",
        "dxHtmlEditor-dialogLinkUrlField": "URL",
        "dxHtmlEditor-dialogLinkTextField": "Testo",
        "dxHtmlEditor-dialogLinkTargetField": "Apri link in una nuova finestra",
        "dxHtmlEditor-dialogImageCaption": "Aggiungi Immagine",
        "dxHtmlEditor-dialogImageUrlField": "URL",
        "dxHtmlEditor-dialogImageAltField": "Testo alternativo",
        "dxHtmlEditor-dialogImageWidthField": "Larghezza (px)",
        "dxHtmlEditor-dialogImageHeightField": "Altezza (px)",
        "dxHtmlEditor-dialogInsertTableRowsField": "Righe",
        "dxHtmlEditor-dialogInsertTableColumnsField": "Colonne",
        "dxHtmlEditor-dialogInsertTableCaption": "Inserisci Tabella",
        "dxHtmlEditor-dialogUpdateImageCaption": "Aggiorna Immagine",
        "dxHtmlEditor-dialogImageUpdateButton": "Aggiorna",
        "dxHtmlEditor-dialogImageAddButton": "Aggiungi",
        "dxHtmlEditor-dialogImageSpecifyUrl": "Dal Web",
        "dxHtmlEditor-dialogImageSelectFile": "Da questo dispositivo",
        "dxHtmlEditor-dialogImageKeepAspectRatio": "Mantieni proporzioni",
        "dxHtmlEditor-dialogImageEncodeToBase64": "Codifica in Base64",
        "dxHtmlEditor-heading": "Intestazione",
        "dxHtmlEditor-normalText": "Testo normale",
        "dxHtmlEditor-background": "Colore di sfondo",
        "dxHtmlEditor-bold": "Grassetto",
        "dxHtmlEditor-color": "Colore testo",
        "dxHtmlEditor-font": "Tipo di carattere",
        "dxHtmlEditor-italic": "Corsivo",
        "dxHtmlEditor-link": "Aggiungi Link",
        "dxHtmlEditor-image": "Aggiungi Immagine",
        "dxHtmlEditor-size": "Dimensioni",
        "dxHtmlEditor-strike": "Barrato",
        "dxHtmlEditor-subscript": "Pedice",
        "dxHtmlEditor-superscript": "Apice",
        "dxHtmlEditor-underline": "Sottolineato",
        "dxHtmlEditor-blockquote": "Citazione",
        "dxHtmlEditor-header": "Intestazione",
        "dxHtmlEditor-increaseIndent": "Aumenta Rientro",
        "dxHtmlEditor-decreaseIndent": "Riduci Rientro",
        "dxHtmlEditor-orderedList": "Elenco Ordinato",
        "dxHtmlEditor-bulletList": "Elenco Puntato",
        "dxHtmlEditor-alignLeft": "Allinea a Sinistra",
        "dxHtmlEditor-alignCenter": "Allinea al Centro",
        "dxHtmlEditor-alignRight": "Allinea a Destra",
        "dxHtmlEditor-alignJustify": "Giustificato",
        "dxHtmlEditor-codeBlock": "Codice",
        "dxHtmlEditor-variable": "Aggiungi Variabile",
        "dxHtmlEditor-undo": "Annulla",
        "dxHtmlEditor-redo": "Ripeti",
        "dxHtmlEditor-clear": "Rimuovi Formattazione",
        "dxHtmlEditor-insertTable": "Inserisci Tabella",
        "dxHtmlEditor-insertHeaderRow": "Inserisci Riga Intestazione",
        "dxHtmlEditor-insertRowAbove": "Inserisci Riga Sopra",
        "dxHtmlEditor-insertRowBelow": "Inserisci Riga Sotto",
        "dxHtmlEditor-insertColumnLeft": "Inserisci Colonna a Sinistra",
        "dxHtmlEditor-insertColumnRight": "Inserisci Colonna a Destra",
        "dxHtmlEditor-deleteColumn": "Elimina Colonna",
        "dxHtmlEditor-deleteRow": "Elimina Riga",
        "dxHtmlEditor-deleteTable": "Elimina Tabella",
        "dxHtmlEditor-cellProperties": "Proprietà Cella",
        "dxHtmlEditor-tableProperties": "Proprietà Tabella",
        "dxHtmlEditor-insert": "Inserisci",
        "dxHtmlEditor-delete": "Elimina",
        "dxHtmlEditor-border": "Bordo",
        "dxHtmlEditor-style": "Stile",
        "dxHtmlEditor-width": "Larghezza",
        "dxHtmlEditor-height": "Altezza",
        "dxHtmlEditor-borderColor": "Colore",
        "dxHtmlEditor-borderWidth": "Spessore Bordo",
        "dxHtmlEditor-tableBackground": "Sfondo",
        "dxHtmlEditor-dimensions": "Dimensioni",
        "dxHtmlEditor-alignment": "Allineamento",
        "dxHtmlEditor-horizontal": "Orizzontale",
        "dxHtmlEditor-vertical": "Verticale",
        "dxHtmlEditor-paddingVertical": "Spaziatura Verticale",
        "dxHtmlEditor-paddingHorizontal": "Spaziatura Orizzontale",
        "dxHtmlEditor-pixels": "Pixel",
        "dxHtmlEditor-list": "Elenco",
        "dxHtmlEditor-ordered": "Ordinato",
        "dxHtmlEditor-bullet": "Puntato",
        "dxHtmlEditor-align": "Allineamento",
        "dxHtmlEditor-center": "Centro",
        "dxHtmlEditor-left": "Sinistra",
        "dxHtmlEditor-right": "Destra",
        "dxHtmlEditor-indent": "Rientro",
        "dxHtmlEditor-justify": "Giustificato",
        "dxHtmlEditor-borderStyleNone": "none",
        "dxHtmlEditor-borderStyleHidden": "hidden",
        "dxHtmlEditor-borderStyleDotted": "dotted",
        "dxHtmlEditor-borderStyleDashed": "dashed",
        "dxHtmlEditor-borderStyleSolid": "solid",
        "dxHtmlEditor-borderStyleDouble": "double",
        "dxHtmlEditor-borderStyleGroove": "groove",
        "dxHtmlEditor-borderStyleRidge": "ridge",
        "dxHtmlEditor-borderStyleInset": "inset",
        "dxHtmlEditor-borderStyleOutset": "outset",
        "dxHtmlEditor-aiDialogTitle": "Assistente AI",
        "dxHtmlEditor-aiDialogError": "Si è verificato un errore. Riprovare.",
        "dxHtmlEditor-aiDialogCanceled": "Generazione annullata",
        "dxHtmlEditor-aiReplace": "Sostituisci",
        "dxHtmlEditor-aiInsertAbove": "Inserisci sopra",
        "dxHtmlEditor-aiInsertBelow": "Inserisci sotto",
        "dxHtmlEditor-aiCopy": "Copia",
        "dxHtmlEditor-aiRegenerate": "Rigenera",
        "dxHtmlEditor-aiGenerate": "Genera",
        "dxHtmlEditor-aiCancel": "Annulla",
        "dxHtmlEditor-aiToolbarItemAriaLabel": "Elemento barra degli strumenti Assistente AI",
        "dxHtmlEditor-aiResultTextAreaAriaLabel": "Risultato Assistente AI",
        "dxHtmlEditor-aiAskPlaceholder": "Chiedi all'AI di modificare il testo",
        "dxHtmlEditor-aiCommandSummarize": "Riassumi",
        "dxHtmlEditor-aiCommandProofread": "Correggi",
        "dxHtmlEditor-aiCommandExpand": "Espandi",
        "dxHtmlEditor-aiCommandShorten": "Accorcia",
        "dxHtmlEditor-aiCommandChangeStyle": "Cambia stile",
        "dxHtmlEditor-aiCommandChangeTone": "Cambia tono",
        "dxHtmlEditor-aiCommandTranslate": "Traduci",
        "dxHtmlEditor-aiCommandAskAI": "Chiedi all'AI",
        "dxHtmlEditor-aiCommandChangeStyleFormal": "Formale",
        "dxHtmlEditor-aiCommandChangeStyleInformal": "Informale",
        "dxHtmlEditor-aiCommandChangeStyleTechnical": "Tecnico",
        "dxHtmlEditor-aiCommandChangeStyleBusiness": "Aziendale",
        "dxHtmlEditor-aiCommandChangeStyleCreative": "Creativo",
        "dxHtmlEditor-aiCommandChangeStyleJournalistic": "Giornalistico",
        "dxHtmlEditor-aiCommandChangeStyleAcademic": "Accademico",
        "dxHtmlEditor-aiCommandChangeStylePersuasive": "Persuasivo",
        "dxHtmlEditor-aiCommandChangeStyleNarrative": "Narrativo",
        "dxHtmlEditor-aiCommandChangeStyleExpository": "Espositivo",
        "dxHtmlEditor-aiCommandChangeStyleDescriptive": "Descrittivo",
        "dxHtmlEditor-aiCommandChangeStyleConversational": "Colloquiale",
        "dxHtmlEditor-aiCommandChangeToneProfessional": "Professionale",
        "dxHtmlEditor-aiCommandChangeToneCasual": "Informale",
        "dxHtmlEditor-aiCommandChangeToneStraightforward": "Diretto",
        "dxHtmlEditor-aiCommandChangeToneConfident": "Sicuro",
        "dxHtmlEditor-aiCommandChangeToneFriendly": "Amichevole",
        "dxHtmlEditor-aiCommandTranslateArabic": "Arabo",
        "dxHtmlEditor-aiCommandTranslateChinese": "Cinese",
        "dxHtmlEditor-aiCommandTranslateEnglish": "Inglese",
        "dxHtmlEditor-aiCommandTranslateFrench": "Francese",
        "dxHtmlEditor-aiCommandTranslateGerman": "Tedesco",
        "dxHtmlEditor-aiCommandTranslateJapanese": "Giapponese",
        "dxHtmlEditor-aiCommandTranslateSpanish": "Spagnolo",

        "dxFileManager-newDirectoryName": "Nuova cartella",
        "dxFileManager-rootDirectoryName": "File",
        "dxFileManager-errorNoAccess": "Permesso di accesso negato. Impossibile proseguire.",
        "dxFileManager-errorDirectoryExistsFormat": "La cartella '{0}' è già presente.",
        "dxFileManager-errorFileExistsFormat": "File '{0}' già esistente.",
        "dxFileManager-errorFileNotFoundFormat": "File '{0}' non trovato.",
        "dxFileManager-errorDirectoryNotFoundFormat": "La cartella '{0}' non è presente.",
        "dxFileManager-errorWrongFileExtension": "L'estensione del file non è consentita.",
        "dxFileManager-errorMaxFileSizeExceeded": "Dimensione file oltre il limite consentito.",
        "dxFileManager-errorInvalidSymbols": "Caratteri non permessi nel nome.",
        "dxFileManager-errorDefault": "Errore non specificato.",
        "dxFileManager-errorDirectoryOpenFailed": "Impossibile aprire la cartella",

        "dxFileManager-commandCreate": "Nuova cartella",
        "dxFileManager-commandRename": "Rinomina",
        "dxFileManager-commandMove": "Sposta",
        "dxFileManager-commandCopy": "Copia",
        "dxFileManager-commandDelete": "Elimina",
        "dxFileManager-commandDownload": "Scarica",
        "dxFileManager-commandUpload": "Carica i files",
        "dxFileManager-commandRefresh": "Aggiorna",
        "dxFileManager-commandThumbnails": "Vista miniature",
        "dxFileManager-commandDetails": "Vista di dettaglio",
        "dxFileManager-commandClearSelection": "Azzera selezione",
        "dxFileManager-commandShowNavPane": "Attiva/disattiva pannello di navigazione",

        "dxFileManager-dialogDirectoryChooserMoveTitle": "Sposta",
        "dxFileManager-dialogDirectoryChooserMoveButtonText": "Sposta",
        "dxFileManager-dialogDirectoryChooserCopyTitle": "Copia",
        "dxFileManager-dialogDirectoryChooserCopyButtonText": "Copia",
        "dxFileManager-dialogRenameItemTitle": "Rinomina",
        "dxFileManager-dialogRenameItemButtonText": "Salva",
        "dxFileManager-dialogCreateDirectoryTitle": "Nuova cartella",
        "dxFileManager-dialogCreateDirectoryButtonText": "Crea",
        "dxFileManager-dialogDeleteItemTitle": "Elimina",
        "dxFileManager-dialogDeleteItemButtonText": "Elimina",
        "dxFileManager-dialogDeleteItemSingleItemConfirmation": "Sei sicuro di voler eliminare {0}?",
        "dxFileManager-dialogDeleteItemMultipleItemsConfirmation": "Sei sicuro di voler eliminare {0} elementi?",
        "dxFileManager-dialogButtonCancel": "Annulla",

        "dxFileManager-editingCreateSingleItemProcessingMessage": "Creazione di una sotto-cartella {0}",
        "dxFileManager-editingCreateSingleItemSuccessMessage": "Creata una sotto-cartella {0}",
        "dxFileManager-editingCreateSingleItemErrorMessage": "La cartella non è stata creata",
        "dxFileManager-editingCreateCommonErrorMessage": "La cartella non è stata creata",

        "dxFileManager-editingRenameSingleItemProcessingMessage": "Rinomina di un elemento {0}",
        "dxFileManager-editingRenameSingleItemSuccessMessage": "Elemento rinominato {0}",
        "dxFileManager-editingRenameSingleItemErrorMessage": "Elemento non rinominato",
        "dxFileManager-editingRenameCommonErrorMessage": "Elemento non rinominato",

        "dxFileManager-editingDeleteSingleItemProcessingMessage": "Cancellazione di un elemento da {0}",
        "dxFileManager-editingDeleteMultipleItemsProcessingMessage": "Cancellazione di {0} elementi da {1}",
        "dxFileManager-editingDeleteSingleItemSuccessMessage": "Cancellazione di un elemento da {0}",
        "dxFileManager-editingDeleteMultipleItemsSuccessMessage": "Cancellati {0} elementi da {1}",
        "dxFileManager-editingDeleteSingleItemErrorMessage": "Elemento non eliminato",
        "dxFileManager-editingDeleteMultipleItemsErrorMessage": "{0} elementi non sono stati cancellati",
        "dxFileManager-editingDeleteCommonErrorMessage": "Alcuni elementi non sono stati eliminati",

        "dxFileManager-editingMoveSingleItemProcessingMessage": "Spostamento di un elemento in {0}",
        "dxFileManager-editingMoveMultipleItemsProcessingMessage": "Spostati {0} elementi in {1}",
        "dxFileManager-editingMoveSingleItemSuccessMessage": "Spostato un elemento in {0}",
        "dxFileManager-editingMoveMultipleItemsSuccessMessage": "Spostati {0} elementi in {1}",
        "dxFileManager-editingMoveSingleItemErrorMessage": "L'elemento non è stato spostato",
        "dxFileManager-editingMoveMultipleItemsErrorMessage": "{0} elementi non sono stati spostati",
        "dxFileManager-editingMoveCommonErrorMessage": "Alcuni elementi non sono stati spostati",

        "dxFileManager-editingCopySingleItemProcessingMessage": "Copia di un elemento in {0}",
        "dxFileManager-editingCopyMultipleItemsProcessingMessage": "Copia di {0} elementi in {1}",
        "dxFileManager-editingCopySingleItemSuccessMessage": "Copiato un elemento in {0}",
        "dxFileManager-editingCopyMultipleItemsSuccessMessage": "Copiati {0} elementi in {1}",
        "dxFileManager-editingCopySingleItemErrorMessage": "Elemento non copiato",
        "dxFileManager-editingCopyMultipleItemsErrorMessage": "{0} elementi non sono stati copiati",
        "dxFileManager-editingCopyCommonErrorMessage": "Alcuni elementi non sono stati copiati",

        "dxFileManager-editingUploadSingleItemProcessingMessage": "Caricamento di un elemento in {0}",
        "dxFileManager-editingUploadMultipleItemsProcessingMessage": "Caricamento di {0} elementi in {1}",
        "dxFileManager-editingUploadSingleItemSuccessMessage": "Caricato un elemento in {0}",
        "dxFileManager-editingUploadMultipleItemsSuccessMessage": "Caricati {0} elementi in {1}",
        "dxFileManager-editingUploadSingleItemErrorMessage": "Elemento non caricato",
        "dxFileManager-editingUploadMultipleItemsErrorMessage": "{0} elementi non sono stati caricati",
        "dxFileManager-editingUploadCanceledMessage": "Annullato",

        "dxFileManager-editingDownloadSingleItemErrorMessage": "Elemento non scaricato",
        "dxFileManager-editingDownloadMultipleItemsErrorMessage": "{0} elementi non sono stati scaricati",

        "dxFileManager-listDetailsColumnCaptionName": "Nome",
        "dxFileManager-listDetailsColumnCaptionDateModified": "Data modificata",
        "dxFileManager-listDetailsColumnCaptionFileSize": "Dimensione file",

        "dxFileManager-listThumbnailsTooltipTextSize": "Dimensione",
        "dxFileManager-listThumbnailsTooltipTextDateModified": "Data modifica",

        "dxFileManager-notificationProgressPanelTitle": "Progressione",
        "dxFileManager-notificationProgressPanelEmptyListText": "Nessuna operazione",
        "dxFileManager-notificationProgressPanelOperationCanceled": "Annullata",

        "dxDiagram-categoryGeneral": "Generale",
        "dxDiagram-categoryFlowchart": "Diagramma di flusso",
        "dxDiagram-categoryOrgChart": "Organigramma",
        "dxDiagram-categoryContainers": "Contenitore",
        "dxDiagram-categoryCustom": "Personalizzato",

        "dxDiagram-commandExportToSvg": "Esporta con formato SVG",
        "dxDiagram-commandExportToPng": "Esporta con formato PNG",
        "dxDiagram-commandExportToJpg": "Esporta con formato JPEG",
        "dxDiagram-commandUndo": "Annulla",
        "dxDiagram-commandRedo": "Ripristina",
        "dxDiagram-commandFontName": "Nome carattere",
        "dxDiagram-commandFontSize": "Dimensione carattere",
        "dxDiagram-commandBold": "Grassetto",
        "dxDiagram-commandItalic": "Italico",
        "dxDiagram-commandUnderline": "Sottolineato",
        "dxDiagram-commandTextColor": "Colore testo",
        "dxDiagram-commandLineColor": "Colore linea",
        "dxDiagram-commandLineWidth": "Spessore linea",
        "dxDiagram-commandLineStyle": "Stile linea",
        "dxDiagram-commandLineStyleSolid": "Continuo",
        "dxDiagram-commandLineStyleDotted": "Punteggiato",
        "dxDiagram-commandLineStyleDashed": "Tratteggiato",
        "dxDiagram-commandFillColor": "Colore riempimento",
        "dxDiagram-commandAlignLeft": "Allineato a sinistra",
        "dxDiagram-commandAlignCenter": "Allineato al centro",
        "dxDiagram-commandAlignRight": "Allineato a destra",
        "dxDiagram-commandConnectorLineType": "Connettore lineare",
        "dxDiagram-commandConnectorLineStraight": "Connettore linea retta",
        "dxDiagram-commandConnectorLineOrthogonal": "Connettore ortogonale",
        "dxDiagram-commandConnectorLineStart": "Connettore iniziale",
        "dxDiagram-commandConnectorLineEnd": "Connettore finale",
        "dxDiagram-commandConnectorLineNone": "Connettore senza linea",
        "dxDiagram-commandConnectorLineArrow": "Connettore indicatore",
        "dxDiagram-commandFullscreen": "Schermo intero",
        "dxDiagram-commandUnits": "Unità",
        "dxDiagram-commandPageSize": "Elementi per pagina",
        "dxDiagram-commandPageOrientation": "Orientamento",
        "dxDiagram-commandPageOrientationLandscape": "Orizzontale",
        "dxDiagram-commandPageOrientationPortrait": "Orient. verticale",
        "dxDiagram-commandPageColor": "Colore",
        "dxDiagram-commandShowGrid": "Mostra griglia",
        "dxDiagram-commandSnapToGrid": "Aggancia alla griglia",
        "dxDiagram-commandGridSize": "Dimensione griglia",
        "dxDiagram-commandZoomLevel": "Livello dettaglio",
        "dxDiagram-commandAutoZoom": "Dettaglio automatico",
        "dxDiagram-commandFitToContent": "Adatta al contenuto",
        "dxDiagram-commandFitToWidth": "Adatta alla larghezza",
        "dxDiagram-commandAutoZoomByContent": "Zoom automatico per contenuto",
        "dxDiagram-commandAutoZoomByWidth": "Zoom automatico per larghezza",
        "dxDiagram-commandSimpleView": "Vista semplice",
        "dxDiagram-commandCut": "Taglia",
        "dxDiagram-commandCopy": "Copia",
        "dxDiagram-commandPaste": "Incolla",
        "dxDiagram-commandSelectAll": "Selez. tutto",
        "dxDiagram-commandDelete": "Elimina",
        "dxDiagram-commandBringToFront": "Primo piano",
        "dxDiagram-commandSendToBack": "Secondo piano",
        "dxDiagram-commandLock": "Blocca",
        "dxDiagram-commandUnlock": "Sblocca",
        "dxDiagram-commandInsertShapeImage": "Ins. immagine",
        "dxDiagram-commandEditShapeImage": "Edit. immagine",
        "dxDiagram-commandDeleteShapeImage": "Del. immagine",
        "dxDiagram-commandLayoutLeftToRight": "Sinistra-destra",
        "dxDiagram-commandLayoutRightToLeft": "Destra-sinistra",
        "dxDiagram-commandLayoutTopToBottom": "Alto-basso",
        "dxDiagram-commandLayoutBottomToTop": "Basso-alto",

        "dxDiagram-unitIn": "in",
        "dxDiagram-unitCm": "cm",
        "dxDiagram-unitPx": "px",

        "dxDiagram-dialogButtonOK": "Conferma",
        "dxDiagram-dialogButtonCancel": "Annulla",
        "dxDiagram-dialogInsertShapeImageTitle": "Ins. immagine",
        "dxDiagram-dialogEditShapeImageTitle": "Modifica immagine",
        "dxDiagram-dialogEditShapeImageSelectButton": "Sel. immagine",
        "dxDiagram-dialogEditShapeImageLabelText": "o trascina file qui",

        "dxDiagram-uiExport": "Esporta",
        "dxDiagram-uiProperties": "Proprietà",
        "dxDiagram-uiSettings": "Impostazioni",
        "dxDiagram-uiShowToolbox": "Mostra casella degli strumenti",
        "dxDiagram-uiSearch": "Cerca",
        "dxDiagram-uiStyle": "Stile",
        "dxDiagram-uiLayout": "Layout",
        "dxDiagram-uiLayoutTree": "Albero",
        "dxDiagram-uiLayoutLayered": "A livelli",
        "dxDiagram-uiDiagram": "Diagramma",
        "dxDiagram-uiText": "Testo",
        "dxDiagram-uiObject": "Oggetto",
        "dxDiagram-uiConnector": "Connettore",
        "dxDiagram-uiPage": "Pagina",

        "dxDiagram-shapeText": "Testo",
        "dxDiagram-shapeRectangle": "Rettangolo",
        "dxDiagram-shapeEllipse": "Ellisse",
        "dxDiagram-shapeCross": "Croce",
        "dxDiagram-shapeTriangle": "Triangolo",
        "dxDiagram-shapeDiamond": "Rombo",
        "dxDiagram-shapeHeart": "Cuore",
        "dxDiagram-shapePentagon": "Pentagono",
        "dxDiagram-shapeHexagon": "Esagono",
        "dxDiagram-shapeOctagon": "Ottagono",
        "dxDiagram-shapeStar": "Stella",
        "dxDiagram-shapeArrowLeft": "Freccia sinistra",
        "dxDiagram-shapeArrowUp": "Freccia su",
        "dxDiagram-shapeArrowRight": "Freccia destra",
        "dxDiagram-shapeArrowDown": "Freccia giù",
        "dxDiagram-shapeArrowUpDown": "Freccia su-giù",
        "dxDiagram-shapeArrowLeftRight": "Freccia sinistra-destra",
        "dxDiagram-shapeProcess": "Processo",
        "dxDiagram-shapeDecision": "Decisione",
        "dxDiagram-shapeTerminator": "Terminatore",
        "dxDiagram-shapePredefinedProcess": "Processo predefinito",
        "dxDiagram-shapeDocument": "Documento",
        "dxDiagram-shapeMultipleDocuments": "Documenti multipli",
        "dxDiagram-shapeManualInput": "Input manuale",
        "dxDiagram-shapePreparation": "Preparazione",
        "dxDiagram-shapeData": "Dati",
        "dxDiagram-shapeDatabase": "Database",
        "dxDiagram-shapeHardDisk": "Disco fisso",
        "dxDiagram-shapeInternalStorage": "Memoria interna",
        "dxDiagram-shapePaperTape": "Nastro di carta",
        "dxDiagram-shapeManualOperation": "Operazione manuale",
        "dxDiagram-shapeDelay": "Ritardo",
        "dxDiagram-shapeStoredData": "Dati memorizzati",
        "dxDiagram-shapeDisplay": "Schermo",
        "dxDiagram-shapeMerge": "Unisci",
        "dxDiagram-shapeConnector": "Connettore",
        "dxDiagram-shapeOr": "O",
        "dxDiagram-shapeSummingJunction": "Giunzione somma",
        "dxDiagram-shapeContainerDefaultText": "Contenitore",
        "dxDiagram-shapeVerticalContainer": "Contenitore verticale",
        "dxDiagram-shapeHorizontalContainer": "Contenitore orizzontale",
        "dxDiagram-shapeCardDefaultText": "Nome persona",
        "dxDiagram-shapeCardWithImageOnLeft": "Scheda con immagine a sinistra",
        "dxDiagram-shapeCardWithImageOnTop": "Scheda con immagine in alto",
        "dxDiagram-shapeCardWithImageOnRight": "Scheda con immagine a destra",

        "dxGantt-dialogTitle": "Titolo",
        "dxGantt-dialogStartTitle": "Inizio",
        "dxGantt-dialogEndTitle": "Fine",
        "dxGantt-dialogProgressTitle": "Avanzamento",
        "dxGantt-dialogResourcesTitle": "Risorse",
        "dxGantt-dialogResourceManagerTitle": "Gestione risorse",
        "dxGantt-dialogTaskDetailsTitle": "Dettagli attività",
        "dxGantt-dialogEditResourceListHint": "Modifica lista risorse",
        "dxGantt-dialogEditNoResources": "Nessuna risorsa",
        "dxGantt-dialogButtonAdd": "Aggiungi",
        "dxGantt-contextMenuNewTask": "Nuova attività",
        "dxGantt-contextMenuNewSubtask": "Nuova sotto-attività",
        "dxGantt-contextMenuDeleteTask": "Elimina attività",
        "dxGantt-contextMenuDeleteDependency": "Elimina dipendenza",
        "dxGantt-dialogTaskDeleteConfirmation": "L'eliminazione di un'attività elimina anche tutte le sue dipendenze e sotto-attività. Sei sicuro di voler eliminare questa attività?",
        "dxGantt-dialogDependencyDeleteConfirmation": "Sei sicuro di voler eliminare la dipendenza dall'attività?",
        "dxGantt-dialogResourcesDeleteConfirmation": "L'eliminazione di una risorsa la rimuove anche dalle attività a cui è assegnata. Sei sicuro di voler eliminare queste risorse? Risorse: {0}",
        "dxGantt-dialogConstraintCriticalViolationMessage": "L'attività che si sta tentando di spostare è collegata a un'altra attività da una relazione di dipendenza. Questa modifica causerebbe conflitti con le regole di dipendenza. Come si desidera procedere?",
        "dxGantt-dialogConstraintViolationMessage": "L'attività che si sta tentando di spostare è collegata a un'altra attività da una relazione di dipendenza. Come si desidera procedere?",
        "dxGantt-dialogCancelOperationMessage": "Annulla l'operazione",
        "dxGantt-dialogDeleteDependencyMessage": "Elimina la dipendenza",
        "dxGantt-dialogMoveTaskAndKeepDependencyMessage": "Sposta l'attività e mantieni la dipendenza",
        "dxGantt-dialogConstraintCriticalViolationSeveralTasksMessage": "L'attività che si sta tentando di spostare è collegata ad altre attività da relazioni di dipendenza. Questa modifica causerebbe conflitti con le regole di dipendenza. Come si desidera procedere?",
        "dxGantt-dialogConstraintViolationSeveralTasksMessage": "L'attività che si sta tentando di spostare è collegata ad altre attività da relazioni di dipendenza. Come si desidera procedere?",
        "dxGantt-dialogDeleteDependenciesMessage": "Elimina le relazioni di dipendenza",
        "dxGantt-dialogMoveTaskAndKeepDependenciesMessage": "Sposta l'attività e mantieni le dipendenze",
        "dxGantt-undo": "Annulla",
        "dxGantt-redo": "Ripristina",
        "dxGantt-expandAll": "Espandi tutto",
        "dxGantt-collapseAll": "Comprimi tutto",
        "dxGantt-addNewTask": "Aggiungi nuova attività",
        "dxGantt-deleteSelectedTask": "Elimina attività selezionata",
        "dxGantt-zoomIn": "Ingrandisci",
        "dxGantt-zoomOut": "Riduci",
        "dxGantt-fullScreen": "Schermo intero",
        "dxGantt-quarter": "Q{0}",
        "dxGantt-sortingAscendingText": "Ordinamento ascendente",
        "dxGantt-sortingDescendingText": "Ordinamento discendente",
        "dxGantt-sortingClearText": "Annulla ordinamento",
        "dxGantt-showResources": "Mostra risorse",
        "dxGantt-showDependencies": "Mostra dipendenze",
        "dxGantt-dialogStartDateValidation": "La data di inizio deve essere successiva al {0}",
        "dxGantt-dialogEndDateValidation": "La data di fine deve essere successiva al {0}",

        "dxGallery-itemName": "Elemento galleria",

        "dxMultiView-elementAriaRoleDescription": "MultiView",
        "dxMultiView-elementAriaLabel": "Usa i tasti freccia o scorri per navigare tra le viste",
        "dxMultiView-itemAriaRoleDescription": "Vista",
        "dxMultiView-itemAriaLabel": "{0} di {1}",

        "dxSplitter-resizeHandleAriaLabel": "Barra di divisione",
        "dxSplitter-resizeHandleAriaRoleDescription": "Separatore",

        "dxStepper-optionalMark": "(Facoltativo)",

        "dxSpeechToText-ariaLabelStart": "Premere per avviare la trascrizione vocale",
        "dxSpeechToText-ariaLabelStop": "Premere per interrompere la trascrizione vocale"
    }
}
